import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BookOpen, Lock, Mail, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLoginPage = ({ onLogin }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      toast.error("Veuillez remplir tous les champs");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, {
        email: email.trim(),
        password: password
      });
      
      toast.success(`Bienvenue ${response.data.name} !`);
      onLogin(response.data, "admin");
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 hero-section"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md">
        <Card className="border-0 shadow-2xl bg-white/95 backdrop-blur">
          <CardHeader className="text-center pb-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/")}
              className="absolute left-4 top-4 text-[#64748B]"
            >
              <ArrowLeft className="w-4 h-4 mr-1" />
              Retour
            </Button>
            
            <div className="flex justify-center mb-4 mt-4">
              <div className="w-20 h-20 rounded-lg bg-[#D4AF37] flex items-center justify-center">
                <Lock className="w-10 h-10 text-[#0F172A]" />
              </div>
            </div>
            <CardTitle className="text-3xl text-[#1A365D]" style={{ fontFamily: 'Playfair Display, serif' }}>
              Administration
            </CardTitle>
            <CardDescription className="text-base text-[#64748B]">
              SJH-PhiloAI • Accès Direction
            </CardDescription>
          </CardHeader>
          
          <CardContent className="pt-4">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-[#0F172A]">Email</Label>
                <div className="relative mt-1">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#64748B]" />
                  <Input 
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre.email@sjh.fr"
                    className="pl-10 border-[#E2E8F0] focus:border-[#1A365D]"
                    data-testid="admin-email-input"
                  />
                </div>
              </div>
              
              <div>
                <Label htmlFor="password" className="text-[#0F172A]">Mot de passe</Label>
                <div className="relative mt-1">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#64748B]" />
                  <Input 
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    className="pl-10 border-[#E2E8F0] focus:border-[#1A365D]"
                    data-testid="admin-password-input"
                  />
                </div>
              </div>
              
              <Button 
                type="submit" 
                className="w-full h-12 bg-[#1A365D] hover:bg-[#132745] text-white"
                disabled={loading}
                data-testid="admin-login-button"
              >
                {loading ? "Connexion..." : "Se connecter"}
              </Button>
            </form>
            
            <p className="text-center text-xs text-[#64748B] mt-6">
              Accès réservé aux administrateurs
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminLoginPage;
